import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { formatDate } from '@angular/common';
import { IsuranceCopmanyService } from 'src/app/services/IsuranceCopmanyService';
import { InsuranceCompanyModel } from 'src/app/models/InsuranceCompanyModel';
import swal from 'sweetalert2';
import { IsuranceCopmanySearchComponent } from '../isurance-copmany-search/isurance-copmany-search.component';

@Component({
  selector: 'app-isurance-copmany',
  templateUrl: './isurance-copmany.component.html',
  styleUrls: ['./isurance-copmany.component.css']
})
export class IsuranceCopmanyComponent implements OnInit {
insid = 0 ;
insenglishname = '' ;
insarabicname = '' ;
insaddress = '' ;
insphone1 = '' ;
insphone2 = '' ;
insemail = '' ;
inscontatpersonname = '' ;
inscontatpersontitle = '' ;
inscontatpersonmobile = '' ;
inscontatpersonemail = '' ;
insapprovalsemail = '' ;
insstartdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
insenddate = formatDate(new Date(), 'yyyy-MM-dd', 'en') ;
inslogo = '' ;
userid = '' ;
modifaieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en') ;
compcode = '' ;

  myimage :any;
  myimage2 = 'data:image/jpg;base64,'
  imageSrc;
  imageSource: any;
  sellersPermitFile: any;
  sellersPermitString = '';
  wk_Acc_Not = false;
  wk_Acc_Not1 = true;

  constructor(
      public insurancecopmapnyservice : IsuranceCopmanyService,
      public isurancecompany : InsuranceCompanyModel,
      public translate: TranslateService,
      public storage: LocalStorageService,
      private sanitizer: DomSanitizer,
      private dialogref: MatDialog) { }

  ngOnInit(): void {
    this. Retrive_Next_Serial();
  }
  Retrive_Next_Serial(){
     this.insurancecopmapnyservice.getIsuranceCopmanySerial().subscribe(
          (data: InsuranceCompanyModel) => {

            this.insid = data.insid;

          }
        );
  }
  switchArabic(){
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchEnglish(){
    this.translate.use('en');
    document.documentElement.dir = "ltr";
  }

OpenDialog(){
   const dialogRef = this.dialogref.open(IsuranceCopmanySearchComponent,
        {
          data: {
            dataKey: this.isurancecompany
          },
          width:'80%'
        });
      dialogRef.afterClosed().subscribe(result => {
      });

      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe(result => {
          this.insid = result.insid;
          this.RetriveCompany();
          dialogSubmitSubscription.unsubscribe();

        });
}
RetriveCompany(){
this.insurancecopmapnyservice.getIsuranceCopmany(this.insid.toString()).subscribe((data: InsuranceCompanyModel) => {


this.insenglishname=data.insenglishname
this.insarabicname=data.insarabicname
this.insaddress=data.insaddress
this.insphone1=data.insphone1
this.insphone2=data.insphone2
this.insemail=data.insemail
this.inscontatpersonname=data.inscontatpersonname
this.inscontatpersontitle=data.inscontatpersontitle
this.inscontatpersonmobile=data.inscontatpersonmobile
this.inscontatpersonemail=data.inscontatpersonemail
this.insapprovalsemail=data.insapprovalsemail
this.insstartdate= formatDate(data.insstartdate, 'yyyy-MM-dd', 'en')
this.insenddate= formatDate(data.insenddate, 'yyyy-MM-dd', 'en')
//this.inslogo=data.inslogo
  ///******* */ this.conimage=data.conimage
        this.myimage = data.inslogo;
        this.sellersPermitString =  data.inslogo;
        this.myimage =this.sellersPermitString;
        var kk = this.sellersPermitString;

        this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.sellersPermitString);
        if(data.inslogo =='' || data.inslogo == null)
          {
            this.wk_Acc_Not = false;
            this.wk_Acc_Not1 = true;
          }
          else
          {
            this.wk_Acc_Not = true;
            this.wk_Acc_Not1 = false;
          }

 }

    );
}
submitContacts(){
this.isurancecompany.insid= this.insid;
this.isurancecompany.insenglishname= this.insenglishname;
this.isurancecompany.insarabicname= this.insarabicname;
this.isurancecompany.insaddress= this.insaddress;
this.isurancecompany.insphone1= this.insphone1;
this.isurancecompany.insphone2= this.insphone2;
this.isurancecompany.insemail= this.insemail;
this.isurancecompany.inscontatpersonname= this.inscontatpersonname;
this.isurancecompany.inscontatpersontitle= this.inscontatpersontitle;
this.isurancecompany.inscontatpersonmobile= this.inscontatpersonmobile;
this.isurancecompany.inscontatpersonemail= this.inscontatpersonemail;
this.isurancecompany.insapprovalsemail= this.insapprovalsemail;
this.isurancecompany.insstartdate= this.insstartdate;
this.isurancecompany.insenddate= this.insenddate;
this.isurancecompany.inslogo= this.sellersPermitString;;
this.isurancecompany.modifaieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
this.isurancecompany.userid = this.storage.retrieve('stguserId');
this.isurancecompany.compcode = this.storage.retrieve('stgcompCode');

    this.insurancecopmapnyservice.AddIsuranceCopmany(this.isurancecompany).subscribe(data => {

      this.mesgSave();
      this.NewData();
    },

      error => { alert(error); }

    );
}
DeletCompany(){
  this.insurancecopmapnyservice.DelIsuranceCopmany(this.insid.toString()).subscribe(
        (data: InsuranceCompanyModel) => {
          this.NewData();
        }
      );
}
MesgDelete(){
   swal({
        title: 'Are you sure?',
        text: 'You will not be able to recover this record!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      }).then(() => {
        this.DeletCompany();
        swal('Deleted!', 'Your record has been deleted.', 'success');

      },
        function (dismiss) {
          if (dismiss === 'cancel') {
            swal('Cancelled', 'Your record is safe :)', 'error');
          }
        }
      );
}
mesgSave() {
    swal({
      title: 'Your work has been saved',

      type: 'success',
      showConfirmButton: false,

      timer: 1500
    });
  }
NewData(){

this.insenglishname = '' ;
this.insarabicname = '' ;
this.insaddress = '' ;
this.insphone1 = '' ;
this.insphone2 = '' ;
this.insemail = '' ;
this.inscontatpersonname = '' ;
this.inscontatpersontitle = '' ;
this.inscontatpersonmobile = '' ;
this.inscontatpersonemail = '' ;
this.insapprovalsemail = '' ;
this.insstartdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
this.insenddate = formatDate(new Date(), 'yyyy-MM-dd', 'en') ;
this.inslogo = '' ;

 this.myimage = '';
  this.wk_Acc_Not = false;
            this.wk_Acc_Not1 = true;
 this.Retrive_Next_Serial()
}

 public picked(event: any) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      this.sellersPermitFile = file;

      this.handleInputChange(file); //turn into base64

    }
    else {
      alert("No file selected");
    }
  }
  handleInputChange(files: any) {
    var file = files;
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }

    reader.onloadend = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }
  _handleReaderLoaded(e: any) {
    let reader = e.target;
    var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    this.imageSrc = base64result;
    this.sellersPermitString = base64result;
    this.myimage =this.sellersPermitString;
    var kk = this.sellersPermitString;

    this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.sellersPermitString);

    if(this.imageSource =='' || this.imageSource == null)
      {
        this.wk_Acc_Not = false;
        this.wk_Acc_Not1 = true;
      }
      else
      {
        this.wk_Acc_Not = true;
        this.wk_Acc_Not1 = false;
      }
  }

}
